const blurFrag =  `
uniform vec2 resolution;
uniform vec2 direction;
uniform vec2 center;
uniform sampler2D tDiffuse;
uniform float blurFactor;
varying vec2 vUv;

vec4 blur5(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.3333333333333333) * direction;
  color += texture2D(image, uv) * 0.29411764705882354;
  color += texture2D(image, uv + (off1 / resolution)) * 0.35294117647058826;
  color += texture2D(image, uv - (off1 / resolution)) * 0.35294117647058826;
  return color;
}

vec4 blur9(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.3846153846) * direction;
  vec2 off2 = vec2(3.2307692308) * direction;
  color += texture2D(image, uv) * 0.2270270270;
  color += texture2D(image, uv + (off1 / resolution)) * 0.3162162162;
  color += texture2D(image, uv - (off1 / resolution)) * 0.3162162162;
  color += texture2D(image, uv + (off2 / resolution)) * 0.0702702703;
  color += texture2D(image, uv - (off2 / resolution)) * 0.0702702703;
  return color;
}

vec4 blur13(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.411764705882353) * direction;
  vec2 off2 = vec2(3.2941176470588234) * direction;
  vec2 off3 = vec2(5.176470588235294) * direction;
  color += texture2D(image, uv) * 0.1964825501511404;
  color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;
  color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;
  color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;
  color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;
  color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;
  color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;
  return color;
}

void main() {
    vec2 uv = vUv;
    vec2 correctAspectUV = (uv - 0.5) * vec2(resolution.x/resolution.y, 1.0) + 0.5;
    vec3 col = texture2D(tDiffuse, uv).rgb;
    vec3 blurCol = blur13(tDiffuse, uv, resolution, direction).rgb;
    float mixFactor = smoothstep(0.4, 0.75, distance(correctAspectUV, center));
    mixFactor *= blurFactor;
    col = mix(col, blurCol, mixFactor);
    col = pow(col, vec3(pow(1.0/2.2, 0.15)));

    float aspect = resolution.x / resolution.y;
    float maxAspect = 2.0;
    float smoothLength = 0.3;
    if (aspect > maxAspect) {
      float pad = (aspect-maxAspect)* 0.5;
      col = mix(vec3(0.753, 0.815, 0.807), col, vec3(smoothstep(pad-smoothLength, pad, vUv.x * aspect )));
      col = mix(vec3(0.753, 0.815, 0.807), col, vec3(smoothstep(maxAspect+smoothLength+pad, maxAspect+pad, vUv.x * aspect )));
    }

    gl_FragColor = vec4(col, 1.0);
    // debug
    // gl_FragColor = mix(vec4(1.0,0.0,0.0,1.0), vec4(0.0,0.0,0.0,1.0), mixFactor);
}
`;
export default blurFrag;
